import React from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { contactsForm } from '../../assets';
import messages from '../../messages';
import GuideBox from '../GuideBox';

const text = {
  strong: <FormattedMessage {...messages.excelDownloadBoxTextStrong} />,
  helper: <FormattedMessage {...messages.excelDownloadBoxTextHelper} />,
};

const S = {
  Link: styled(Button).attrs({ component: 'a' })`
    min-height: 40px;
    border-color: ${({ theme }) => theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
};

const ExcelDownloadBox = () => (
  <GuideBox
    text={text}
  >
    <S.Link href={contactsForm} color="primary" variant="outlined" download="CLASSTING contacts">
      <FormattedMessage {...messages.excelDownloadBoxLink} />
    </S.Link>
  </GuideBox>
);

export default ExcelDownloadBox;
